import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'antd';
import driveLogo from '../../../assets/img/google-drive.png';
import { Link } from 'react-router-dom';
import googleDrive from '../../../Actions/googleDrive';
const { selectTab } = googleDrive.actions;

class GoogleDriveMessage extends Component {

    render() {        
        return(
            <Alert
                message = { 
                    <div style={{display: 'flex', alignItems:'center'}}>
                        <img src={driveLogo} alt=""  style={{paddingRight: '10px'}}/>
                        <p className="margin-0">
                            Actualmente no cuentas con una cuenta vinculada de Google
                            Para programar tu descarga en Google Drive ve a <Link to='/settings' onClick={this.goToSettingsTab.bind(this,'4')}>Configuración</Link> para vincular una cuenta de Google
                        </p>
                    </div>
                }			
                closable
			/>
        );
    }

    goToSettingsTab (tab) {
		this.props.selectTab(tab);
	}
}
const mapDispatchToProps = dispatch => {
    return {
        selectTab(tab) {
            dispatch(selectTab(tab))
        }
    }
}

export default connect(null,mapDispatchToProps)(GoogleDriveMessage);